import React from 'react';
import {
  Box, Container, Grid, Typography,
} from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { useLoyaltyPageContext } from '../../context';
import cashbackIcon from './assets/cashback.svg';
import EarnPointsCard from './EarnPointsCard';

const EarnPoints: React.FC = () => {
  const { t } = useTranslation();
  const {
    missions,
    colors: {
      mainFontColor,
    },
    currentUserCashBack,
    isMobilePreview,
  } = useLoyaltyPageContext();

  return (
    <Box
      bgcolor="background.paper"
      py={{
        xs: 4.5,
        sm: 9,
      }}
    >
      <Container
        maxWidth="lg"
        disableGutters
      >
        <Typography variant="h1" gutterBottom sx={{ textAlign: 'center' }}>
          {t('loyaltyPage.earn.title', 'Ways to Earn Points')}
        </Typography>
      </Container>

      <Container
        maxWidth="lg"
        sx={{
          mt: {
            xs: 4.5,
            sm: 9,
          },
        }}
      >
        <Grid
          container
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={2}
          justifyContent="center"
        >
          {
            currentUserCashBack > 0 && (
              <Grid size={{ xs: 12, sm: isMobilePreview ? 12 : 6, md: isMobilePreview ? 12 : 4 }}>
                <EarnPointsCard
                  icon={cashbackIcon}
                  mainFontColor={mainFontColor}
                  title={(
                    <Trans
                      i18nKey="loyaltyPage.cashback.description"
                      defaults="Make a purchase and get <span>{{currentCashBack}}% </span> back in {{,gems}}"
                      values={{
                        currentCashBack: currentUserCashBack,
                      }}
                      components={{ span: <span /> }}
                    />
                  )}
                />
              </Grid>
            )
          }
          {
            missions?.map(({
              id, icon, title, points,
            }) => (
              <Grid key={id} size={{ xs: 12, sm: isMobilePreview ? 12 : 6, md: isMobilePreview ? 12 : 4 }}>
                <EarnPointsCard
                  icon={icon}
                  title={title}
                  points={points}
                  mainFontColor={mainFontColor}
                />
              </Grid>
            ))
          }
        </Grid>
      </Container>
    </Box>
  );
};

export default observer(EarnPoints);
